import script from "./FeedbackButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeedbackButton.vue?vue&type=script&setup=true&lang=ts"

import "./FeedbackButton.vue?vue&type=style&index=0&id=5bbcedd3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/The-Jojo-Tree/The-Jojo-Tree/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bbcedd3"]])

export default __exports__